import { format } from 'date-fns';

/** 一覧やツールバーに添える短い日時（`MM/dd HH:mm`）。読めない値なら null。 */
export function formatShortDateTime(value: string | null | undefined): string | null {
  if (!value) return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : format(date, 'MM/dd HH:mm');
}
